import { Component } from 'react';
import { Button } from 'react-bootstrap';
import Immutable from 'immutable';
import cx from 'classnames';
import MultiChoiceResponse from './MultiChoiceResponse';
import style from './MultiAnswerMultiChoiceQuestion.scss';
import { createInstructionMarkup, questionComponentPropTypes } from './helpers';

class MultiAnswerMultiChoiceQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: !this.submittedAnswers().isEmpty(),
    };
  }

  handleResponseChange = (e) => {
    this.setState({
      showResult: false,
    });
    const value = parseInt(e.target.value, 10);

    const submittedAnswers = this.submittedAnswers();

    const newAnswers = !submittedAnswers.contains(value)
      ? submittedAnswers.push(value)
      : submittedAnswers.remove(submittedAnswers.indexOf(value));

    this.props.onResponseChange(
      this.props.response.set('submitted_answers', newAnswers)
    );
  };

  handleSaveClick = () => {
    this.setState({
      showResult: true,
    });
    this.props.onSaveClick();
  };

  submittedAnswers = () => {
    return this.props.response.get('submitted_answers') || Immutable.List();
  };

  render = () => {
    return (
      <div
        className={cx('question multi-choice multi-answer', {
          [style.slideshow]: this.props.isSlideshow,
        })}
      >
        <span
          dangerouslySetInnerHTML={createInstructionMarkup(this.props.question)}
        />
        <MultiChoiceResponse
          allowMultiSelect
          showResult={this.state.showResult}
          answers={this.props.question.get('answers')}
          checked={this.submittedAnswers().toJS()}
          stats={this.props.quizStats}
          onChange={this.handleResponseChange}
          isSlideshow={this.props.isSlideshow}
        />
        <Button
          onClick={this.handleSaveClick}
          disabled={this.submittedAnswers().isEmpty() || this.props.isSaving}
          className={cx({
            [style.button]: this.props.isSlideshow,
          })}
        >
          Save &amp; continue &raquo;
        </Button>
      </div>
    );
  };
}

MultiAnswerMultiChoiceQuestion.propTypes = questionComponentPropTypes;
MultiAnswerMultiChoiceQuestion.defaultProps = {
  response: Immutable.Map(),
};

export default MultiAnswerMultiChoiceQuestion;
